import libphonenumber, { PhoneNumberFormat } from "google-libphonenumber";	

const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();
	
	export const formatToE164 = (phoneNumber) => {
  try {
    const parsedNumber = phoneUtil.parse(phoneNumber); // works if input has '+' prefix
    if (phoneUtil.isValidNumber(parsedNumber)) {
      return phoneUtil.format(parsedNumber, PhoneNumberFormat.E164);
    }
    return null;
  } catch {
    return null;
  }
};